// ============================================================================
// HAI Reporting Tool - Authentication Page
// Login and signup forms with tab switching
// ============================================================================

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/components/auth/LoginForm';
import { SignupForm } from '@/components/auth/SignupForm';

export function AuthPage() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const navigate = useNavigate();

  const handleAuthSuccess = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-600 mb-2">
            HAI Reporting Tool
          </h1>
          <p className="text-gray-600">
            Healthcare-Associated Infections Surveillance
          </p>
        </div>

        {/* Auth Forms */}
        {mode === 'login' ? (
          <LoginForm
            onSuccess={handleAuthSuccess}
            onSwitchToSignup={() => setMode('signup')}
          />
        ) : (
          <SignupForm
            onSuccess={handleAuthSuccess}
            onSwitchToLogin={() => setMode('login')}
          />
        )}

        {/* Footer */}
        <div className="mt-8 text-center text-xs text-gray-500">
          <p>POPIA Compliant • No Patient Identifiable Data</p>
        </div>
      </div>
    </div>
  );
}
